import { loadExternal, loadScriptCallback } from './mosaic/util/load-external';
import { emit } from './mosaic/util/emit';
import * as detect from './mosaic/util/detect-all';
import { getComponentPath } from './mosaic/util/config';
import { getPriorities, getDeps, getBundles } from './core/modules/util/bundles';

const ready = () => {    
    //console.log('dependencies and bundles loaded...');
    emit(document, 'oneadvancedLoaded');
};

const mapScripts = () => {
    // what happens when manifest has been cached??? this file should not be cached.
    fetch(`/Static/js/scriptsMap.json?${Date.now()}`) // add a time stamp
        .then(response => response.json())
        .then(scripts => loader(scripts));
};

const loader = (scripts) => {
    // load in the core files
    let bundlePromise = Promise.resolve();
    let priorities = [];
    let deps = [];
    let bundles = [];

    // does the browser support basic ES6?
    if (!detect.all('symbols', 'class', 'const', 'arrowFunction') || !('forEach' in NodeList.prototype)) {
        deps = [
            { url: getComponentPath('/polyfills.iife.js'), is: 'script' },
            ...deps
        ]
    }

    priorities = [
        ...priorities,
        ...getPriorities(scripts)
    ];

    deps = [
        ...deps,
        ...getDeps(scripts)
    ];

    bundles = [
        ...bundles,
        ...getBundles(scripts)
    ];

    if (window.oneadvanced.required.customtablayoutblock) {
        bundles.push({ url: scripts['customtablayoutblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.backtotop) {
        bundles.push({ url: scripts['backtotop.js'], is: 'script' });
    }

    if (window.oneadvanced.required.breadcrumbschema) {
        bundles.push({ url: scripts['breadcrumbschema.js'], is: 'script' });
    }

    if (window.oneadvanced.required.vacancies) {
        bundles.push({ url: scripts['vacancies.js'], is: 'script' });
    }

    if (window.oneadvanced.required.lazyload) {
        bundles.push({ url: scripts['lazyload.js'], is: 'script' });
    }

    if (window.oneadvanced.required.angularjs) {
        deps.push({ url: scripts['angular.js'], is: 'script' });
        deps.push({ url: scripts['angular-lazy-image.js'], is: 'script' });
        deps.push({ url: scripts['ang.js'], is: 'script' });
    }

    if (window.oneadvanced.required.observer) {
        bundles.push({ url: scripts['observer.js'], is: 'script' });
    }

    if (window.oneadvanced.required.mobile) {
        bundles.push({ url: scripts['mobile.js'], is: 'script' });
    }

    if (window.oneadvanced.required.advancedproductsnav) {
        bundles.push({ url: scripts['advancedproductsnav.js'], is: 'script' });
    }

    if (window.oneadvanced.required.carousellayoutblock) {
        bundles.push({ url: scripts['carousellayoutblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.casestudycarouselblock) {
        bundles.push({ url: scripts['casestudycarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.form && window.oneadvanced.required.form.tooltip) {
        bundles.push({ url: scripts['form_tooltip.js'], is: 'script' });
    }

    if (window.oneadvanced.required.layout) {
        bundles.push({ url: scripts['layout.js'], is: 'script' });
    }

    if (window.oneadvanced.required.navigation) {
        bundles.push({ url: scripts['navigation.js'], is: 'script' });
    }

    if (window.oneadvanced.required.evpnavigation) {
        bundles.push({ url: scripts['evpnavigation.js'], is: 'script' });
    }

    if (window.oneadvanced.required.productfinderblock) {
        bundles.push({ url: scripts['productfinderblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.productresourceblock) {
        bundles.push({ url: scripts['productresourceblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.reactiveimageblock) {
        bundles.push({ url: scripts['reactiveimageblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.responsivetabscarouselblock) {
        bundles.push({ url: scripts['responsivetabscarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.showcasecarouselblock) {
        bundles.push({ url: scripts['showcasecarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.statisticsblock) {
        bundles.push({ url: scripts['statisticsblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.testimonialcarouselblock) {
        bundles.push({ url: scripts['testimonialcarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.dropdownnavigationblock) {
        bundles.push({ url: scripts['dropdownnavigationblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.herocarouselbannerblock) {
        bundles.push({ url: scripts['herocarouselbannerblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.stickyimageblock) {
        bundles.push({ url: scripts['stickyimageblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.stickyheaderblock) {
        bundles.push({ url: scripts['stickyheaderblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.campaignpage) {
        bundles.push({ url: scripts['campaignpage.js'], is: 'script' });
    }

    if (window.oneadvanced.required.billboardblock) {
        bundles.push({ url: scripts['billboardblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.iframeblock) {
        bundles.push({ url: scripts['iframeblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.alternativelanguageselectorservice) {
        bundles.push({ url: scripts['alternativelanguageselectorservice.js'], is: 'script' });
    }

    if (window.oneadvanced.required.articlepage) {
        bundles.push({ url: scripts['articlepage.js'], is: 'script' });
    }

    if (window.oneadvanced.required.megaheader) {
        bundles.push({ url: scripts['megaheader.js'], is: 'script' });
    }

    if (window.oneadvanced.required.regionbar) {
        bundles.push({ url: scripts['regionbarblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.capabilitiesverticaltabsblock) {
        bundles.push({ url: scripts['capabilitiesverticaltabsblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.pricingplancardsblock) {
        bundles.push({ url: scripts['pricingplancardsblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.challengesblock) {
        bundles.push({ url: scripts['challengesblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.customersblock) {
        bundles.push({ url: scripts['customersblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.resourcelinksblock) {
        bundles.push({ url: scripts['resourcelinksblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.timelineblock) {
        bundles.push({ url: scripts['timelineblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedcontactusblock) {
        bundles.push({ url: scripts['refreshedcontactusblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedcampaignbookademoblock) {
        bundles.push({ url: scripts['refreshedcampaignbookademoblock.js'], is: 'script' });
    }
    
    if (window.oneadvanced.required.refreshedhelpmechooseblock) {
        bundles.push({ url: scripts['refreshedhelpmechooseblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedcustomerfeedbackcarouselblock) {
        bundles.push({ url: scripts['refreshedcustomerfeedbackcarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedproductsoftwaregalleryblock) {
        bundles.push({ url: scripts['refreshedproductsoftwaregalleryblock.js'], is: 'script' });
    }
    
    if (window.oneadvanced.required.refreshedtablelayoutblock) {
        bundles.push({ url: scripts['refreshedtablelayoutblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedourstoryhistorysliderblock) {
        bundles.push({ url: scripts['refreshedourstoryhistorysliderblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedproductheroblock) {
        bundles.push({ url: scripts['refreshedproductheroblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedfeaturestabsblock) {
        bundles.push({ url: scripts['refreshedfeaturestabsblock.js'], is: 'script' });
    }
    
    if (window.oneadvanced.required.refreshedrecommendationcarouselblock) {
        bundles.push({ url: scripts['refreshedrecommendationcarouselblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedhubgridblock) {
        bundles.push({ url: scripts['refreshedhubgridblock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.refreshedtextovermediablock) {
        bundles.push({ url: scripts['refreshedtextovermediablock.js'], is: 'script' });
    }

    if (window.oneadvanced.required.videogridblock) {
        bundles.push({ url: scripts['videogridblock.js'], is: 'script' });
    }

    // Map through each file and load separately so that we can catch errors and continue loading
    // subsequent files even after a file fails to load.
    bundlePromise
        .then(() => Promise.all(priorities.map(p => loadExternal(p).catch(e => console.error(e)))))
        .then(() => Promise.all(deps.map(d => loadExternal(d).catch(e => console.error(e)))))
        .then(() => Promise.all(bundles.map(b => loadExternal(b).catch(e => console.error(e)))))
        .then(ready);
};

// create default window namespace
window.oneadvanced = window.oneadvanced || {};

// we need promises and fetch so check if they're available first unless we've been told to ignore them
if (!detect.all('promise', 'fetch')) {
    loadScriptCallback({ url: getComponentPath('/deps.iife.js'), is: 'script' }, mapScripts);
} else {
    mapScripts();
}